import type { FC } from "react";

import CheckVerify from "@/assets/images/CheckVerify";
import { DialogBody, SimpleText } from "@/components/atoms";
import { Dialog } from "@/components/ui/dialog";

interface ActionSuccessfullyProps {
  userName: string;
  state: string;
  callback: (a: boolean) => void;
  successAction: string;
}

const ActionSuccessfully: FC<ActionSuccessfullyProps> = ({
  userName,
  state,
  callback,
  successAction,
}) => {
  return (
    <Dialog open onOpenChange={callback}>
      <DialogBody>
        <div
          className="flex flex-col items-center px-6 pt-12 gap-2 mb-7"
          data-testid="deactivate-send-dialog"
        >
          <CheckVerify />
          <h4 className="text-lg font-extrabold">
            {state} {successAction}!
          </h4>
          <SimpleText classes="text-center">
            {state} “{userName}” was {successAction} successfully
          </SimpleText>
        </div>
      </DialogBody>
    </Dialog>
  );
};

export default ActionSuccessfully;
